<template>
  <Text variant="label-small" :class="statusColorCoding" class="showing-status-label">
    {{ props.showingStatus }}
  </Text>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { Text } from '@tallo/design-system';

import { ShowingStatus } from '../interfaces/showing-status.enum';

const props = defineProps<{
  showingStatus: ShowingStatus;
}>();

const statusColorCoding = computed(() => ({
  confirmed: props.showingStatus === ShowingStatus.CONFIRMED,
  pending: props.showingStatus === ShowingStatus.PENDING,
  completed: props.showingStatus === ShowingStatus.COMPLETED,
  canceled: props.showingStatus === ShowingStatus.CANCELED,
  declined: props.showingStatus === ShowingStatus.DECLINED,
  expired: props.showingStatus === ShowingStatus.EXPIRED,
}));
</script>

<style scoped lang="scss">
.showing-status-label {
  width: fit-content;
  padding: 0.25rem 0.5rem;
  border-radius: var(--t-border-radius-xs);
  display: inline-block;

  &.confirmed {
    background-color: var(--t-color-green-200);
  }

  &.canceled {
    background-color: var(--t-color-neutral-200);
  }

  &.pending {
    background-color: var(--t-color-yellow-100);
  }

  &.completed {
    background-color: var(--t-color-blue-200);
  }

  &.declined {
    background-color: var(--t-color-red-200);
  }

  &.expired {
    background-color: var(--t-color-neutral-200);
  }
}
</style>
